import { LOCALES } from "utils";

const translation = {
  [LOCALES.FA]: {
    SHARE: "اشتراک گذاری با",
    PUBLISH_DATE: "تاریخ رویداد",
    PUBLISH_TIME: "زمان رویداد",
    SEE_MORE: "مشاهده بیشتر",
    TELL: "شماره تماس",
    EMAIL: "نشانی الکترونیکی",
    COPIED: "لینک با موفقیت کپی شد",
    BREADCRUMB: (news) => [
      { title: "اعلانات", link: "/news?tab=events" },
      { title: news?.["title"]?.value ?? "جزییات اعلان" },
    ],
  },
  [LOCALES.EN]: {
    SHARE: "Share with",
    PUBLISH_DATE: "Published",
    PUBLISH_TIME: "Event time",
    SEE_MORE: "See More",
    TELL: "Phone number",
    EMAIL: "Email Address",
    COPIED: "Link Copied Successfully.",
    BREADCRUMB: (news) => [
      { title: "Events", link: "/news?tab=events" },
      { title: news?.["title"]?.value ?? "Event Details" },
    ],
  },
};

export default translation;
